import { z } from 'zod';
import type { CommunicationsResourceChangedNotification } from '../../../../../api/generated/models/CommunicationsResourceChangedNotification';
import { schema } from '../../../../../api/generated/schemas/CommunicationsResourceChangedNotification';

const validator = z.fromJSONSchema(schema);

/** Validates the generated compact contract; notifications never become snapshots. */
export const resourceChangedNotificationSchema =
  z.custom<CommunicationsResourceChangedNotification>(
    (value) => validator.safeParse(value).success
  );
